import { Pipe, PipeTransform } from '@angular/core';
import { JavapiService } from '../services/javapi.service';
import { firstValueFrom } from 'rxjs';

@Pipe({
  name: 'imageAuth',
  pure: true, // Cache results based on input arguments
  standalone: false
})
export class ImageAuthPipe implements PipeTransform {

  constructor(private javapiService: JavapiService) { }

  async transform(imagenPath: string, configKey: string = 'path_img_medidas'): Promise<string> {
    if (!imagenPath) return '';
    try {
      const base64 = await firstValueFrom(this.javapiService.getImage(imagenPath, configKey));
      if (!base64 || base64.length < 100) return ''; // Invalid
      return 'data:image/jpeg;base64,' + base64;
    } catch (e) {
      console.error('Error loading image auth:', e);
      return '';
    }
  }

}
